import Icon from "@ant-design/icons";
import { useSelector } from "react-redux";

const MaxIconSVG = (props) => {
  const themeDefault = useSelector((state) => state.themeDefault);
  let themeValue = themeDefault?.info?.newConfig;
  const predefinedSizes = {
    small: { ...themeValue?.fontSmlSize?.size },
    medium: { ...themeValue?.fontMediumSize?.size },
    large: { ...themeValue?.fontLgSize?.size },
  };
  const { size, width, height } = props;
  const finalSize = predefinedSizes[size] || { width, height };
  return (
    <svg
      width={finalSize.width || "24"}
      height={finalSize.height || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.15418 10.1544C5.10362 10.548 3.12222 9.20475 2.7286 7.15418C2.33499 5.10362 3.67822 3.12222 5.72878 2.7286C7.77935 2.33499 9.76075 3.67822 10.1544 5.72878C10.548 7.77935 9.20475 9.76075 7.15418 10.1544ZM10.6868 12.3277C11.0779 12.2526 11.4559 12.5089 11.531 12.9L12.663 18.7974C12.7381 19.1886 12.4819 19.5666 12.0907 19.6417L6.19329 20.7737C5.80212 20.8488 5.42415 20.5925 5.34907 20.2014L4.21704 14.304C4.14196 13.9128 4.39819 13.5348 4.78935 13.4598L10.6868 12.3277ZM20.5584 8.97019C21.083 9.15216 21.2138 9.83369 20.7939 10.1969L16.2093 14.1635C15.7895 14.5267 15.1339 14.2992 15.0292 13.754L13.8864 7.80038C13.7817 7.25516 14.3065 6.80111 14.831 6.98308L20.5584 8.97019Z"
        stroke="currentColor"
        stroke-width="1.32"
      />
    </svg>
  );
};
const MaxIcon = (props) => {
  const themeDefault = useSelector((state) => state.themeDefault);
  let themeValue = themeDefault?.info?.newConfig;
  const { size, color } = props;
  const predefinedSizes = {
    small: themeValue?.fontSmlSize,
    medium: themeValue?.fontMediumSize,
    large: themeValue?.fontLgSize,
  };
  return (
    <Icon
      component={MaxIconSVG}
      style={{
        fontSize: predefinedSizes[size] || predefinedSizes.medium,
      }}
      {...props}
    />
  );
};

export default MaxIcon;
